import { IColumnDefinition } from '@amp/column-picker';
import { ISiteMonitoringColumnPickerExtraConfig } from '../model/site-monitoring-column-picker-extra-config.interface';
import { SITE_MONITORED_VALUE_COLUMNS, SITE_PROPERTY_COLUMNS } from '../model/site-monitoring-columns';

/**
 * Retrieves the column definition from a column id
 * **/
export const getSiteMonitoringColumnDefinition = (id: string): IColumnDefinition<ISiteMonitoringColumnPickerExtraConfig> => [...SITE_PROPERTY_COLUMNS, ...SITE_MONITORED_VALUE_COLUMNS].find((column) => id === column.id);
